import {
  MAKE_OFFER_ERROR_MESSAGES,
  DEFAULT_MAKE_OFFER_ERROR_MESSAGE,
} from 'site-modules/shared/constants/error-handlers';

export function classifyFetchError(error) {
  if (error.name === 'TimeoutError' || error.name === 'AbortError' || error.status === 408) {
    return 'NETWORK_TIMEOUT';
  }
  if (error.status && error.status !== 0) {
    return 'HTTP_ERROR';
  }
  if (error.message === 'Failed to fetch' || error.name === 'TypeError') {
    return 'CORS_OR_DISCONNECT';
  }
  return 'CLIENT_ABORT';
}

export function sanitizeApiEndpoint(url) {
  try {
    const { pathname } = new URL(url);
    return pathname.replace(/^\/api\//, '').replace(/^\//, '');
  } catch {
    return url || '';
  }
}

export function buildFailedToFetchErrorValue(error) {
  if (!error?.message?.includes('Failed to fetch')) {
    return error?.message || 'Unrecognized error';
  }
  const errorType = classifyFetchError(error);
  const status = error?.status || 0;
  const endpoint = sanitizeApiEndpoint(error?.apiUrl || '');
  return `Failed to fetch . ${errorType} . ${status} . ${endpoint}`;
}

export function getMakeOfferErrorMessage(errorMessage) {
  const match = MAKE_OFFER_ERROR_MESSAGES.find(({ pattern }) => pattern.test(errorMessage));
  return match ? match.message : DEFAULT_MAKE_OFFER_ERROR_MESSAGE;
}
